import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { backend, ReprocessStage } from "Backend";
import { ChangeEvent, useState } from "react";
import useSnackbarPromise from "../../../../../helpers/hooks/useSnackbarPromise";

export interface ReprocessDocumentsProps {
  open: boolean;
  close: () => void;
  documentId: number;
  caseId: number;
}

const ReprocessDocumentsDialog = (props: ReprocessDocumentsProps) => {
  const { open, close, documentId, caseId } = props;
  const [reprocessing, setReprocessing] = useState<boolean>(false);

  const [priorityValue, setPriorityValue] = useState<boolean>(false);
  const handlePriorityValueChange = (event: ChangeEvent<HTMLInputElement>) => setPriorityValue(event.target.checked);

  const snackbarPromise = useSnackbarPromise();

  const [stageValue, setStageValue] = useState<ReprocessStage>("re_wits");
  const handleStageValueChange = (event: ChangeEvent<HTMLInputElement>) =>
    setStageValue(event.target.value as ReprocessStage);

  const reprocessDocument = async (documentId: number, caseId: number, stage: ReprocessStage, priority: boolean) => {
    setReprocessing(true);
    snackbarPromise(backend.reprocessDocuments(caseId, [documentId], stage, priority, false), {
      successMessage: "Reprocess request successful",
      errorMessage: "Unable to reprocess document. Please try again later.",
    })
      .then(() => {
        close();
      })
      .finally(() => setReprocessing(false));
  };

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>Reprocess Document</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ marginBottom: 16 }}>Choose how to reprocess your document</DialogContentText>
        <FormControl component="fieldset">
          <FormLabel component="legend">Stage</FormLabel>
          <RadioGroup
            aria-label="reprocess stage"
            name="reprocessstage"
            value={stageValue}
            onChange={handleStageValueChange}>
            <FormControlLabel value="re_extract" control={<Radio />} label="Extraction" />
            <FormControlLabel value="re_wits" control={<Radio />} label="Entity Detection" />
            <FormControlLabel value="re_index" control={<Radio />} label="Index" />
          </RadioGroup>
        </FormControl>
        <FormControlLabel
          style={{ display: "block" }}
          control={<Checkbox checked={priorityValue} onChange={handlePriorityValueChange} name="priority" />}
          label="Run with priority"
        />
      </DialogContent>
      <DialogActions>
        <Button color="default" onClick={close}>
          Cancel
        </Button>
        <Button
          color="default"
          variant="contained"
          disabled={reprocessing}
          onClick={() => reprocessDocument(documentId, caseId, stageValue, priorityValue)}>
          {reprocessing ? "Reprocessing" : "Reprocess"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReprocessDocumentsDialog;
